import React from "react";
import { IIcons } from "./icons";

const Cloud = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg
      width="25"
      height="18"
      viewBox="0 0 25 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={fillColor}
    >
      <path
        d="M11.5 0.5C7.92578 0.5 4.95703 2.91016 3.9375 6.15625C1.92969 7.125 0.5 9.12891 0.5 11.5C0.5 14.8008 3.19922 17.5 6.5 17.5H18.5C21.8008 17.5 24.5 14.8008 24.5 11.5C24.5 8.32031 21.9805 5.75 18.8438 5.5625C17.6602 2.62109 14.8555 0.5 11.5 0.5ZM11.5 2.5C14.2344 2.5 16.5195 4.32422 17.25 6.8125L17.4688 7.5625L18.2812 7.53125C18.4961 7.51953 18.5586 7.5 18.5 7.5C20.7227 7.5 22.5 9.27734 22.5 11.5C22.5 13.7188 20.7227 15.5 18.5 15.5H6.5C4.27734 15.5 2.5 13.7188 2.5 11.5C2.5 9.78906 3.5625 8.35938 5.0625 7.78125L5.5625 7.59375L5.6875 7.09375C6.32422 4.46875 8.66797 2.5 11.5 2.5ZM10.5 6.5V10.5H8.75L11.5 14.25L14.25 10.5H12.5V6.5H10.5Z"
        fill="white"
      />
    </svg>
  );
};

export default Cloud;
